export const Pluralizer = () => {
  const getPluralText = (count, forms, singularVerb = null, pluralVerb = null) => {
    if (forms.length !== 3) {
      throw new Error('Forms array must contain exactly 3 elements.');
    }

    const getPluralForm = (n) => {
      if (n % 10 === 1 && n % 100 !== 11) return forms[0];
      if ([2, 3, 4].includes(n % 10) && ![12, 13, 14].includes(n % 100)) return forms[1];
      return forms[2]; // 5+
    };

    if (singularVerb && pluralVerb) {
      const verb = count === 1 ? singularVerb : pluralVerb;
      return `${verb} ${count} ${getPluralForm(count)}`;
    }

    return `${count} ${getPluralForm(count)}`;
  };

  return {
    getPluralText,
  };
};
